import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementWorkRequestDocumentTypeComponent } from './case-management-work-request-document-type.component';

const routes: Routes = [{ path: '', component: CaseManagementWorkRequestDocumentTypeComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementWorkRequestDocumentTypeRoutingModule { }
